module.exports = __webpack_public_path__ + "img/img.81ec9876.svg";